export interface Review {
  message: string;
  image: string;
  name: string;
  title: string;
}

export const reviews: Review[] = [
  {
    name: "Abigail M.",
    image: "/images/userr.jpg",
    message:
      "I was overwhelmed with my case until this firm stepped in. They explained every step clearly and fought for my rights with real dedication. I felt supported throughout the entire process.",
    title: "Civil Litigation Client",
  },
  {
    name: "James K.",
    image: "/images/userr.jpg",
    message:
      "The team was responsive, professional, and incredibly knowledgeable. They helped me resolve a business dispute quickly and protected my company’s interests from day one.",
    title: "Business Owner",
  },
  {
    name: "Linda O.",
    image: "/images/userr.jpg",
    message:
      "What stood out most was their compassion and attention to detail. They handled my family matter with sensitivity while still being firm and strategic in negotiations.",
    title: "Family Law Client",
  },
  {
    name: "Michael T.",
    image: "/images/userr.jpg",
    message:
      "Their legal expertise is unmatched. They guided me through a complex legal issue and delivered a result far better than I expected. I highly recommend their services.",
    title: "Corporate Client",
  },
  {
    name: "Sarah W.",
    image: "/images/userr.jpg",
    message:
      "From the first consultation, I knew I was in good hands. They were honest, transparent, and truly fought for the best possible outcome. I'm grateful for their dedication.",
    title: "Personal Injury Client",
  },
  {
    name: "David R.",
    image: "/images/userr.jpg",
    message:
      "Professional, trustworthy, and highly efficient. They handled my case with confidence and gave me peace of mind during a stressful time. Exceptional service all around.",
    title: "Criminal Defense Client",
  },
];
